import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  roomMakeStateRecoil,
} from '../../atom/ModalAtom';
import { RoomMakeDto } from '../../model/room.dto';
import { userIdState } from '../../atom/TokenAtom';
import { roomAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

const RoomMake = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const navigate = useNavigate();

  const setModalState = useSetRecoilState(roomMakeStateRecoil);

  const [roomTitle, setRoomTitle] = useState('');
  const [roomTitleDuplication, setRoomTitleDuplication] = useState(false);
  const [mainPassword, setMainPassword] = useState('');
  const [subPassword, setSubPassword] = useState('');

  const handleRoomTitleDuplication = async () => {
    if (roomTitle === '') {
      setError(blankMsg);
      return;
    }

    if (roomTitle.length > 18) {
      setError('방 제목은 18자 이하여야 합니다.');
      return;
    }

    try {
      await roomAPI.getRoomTitleDuplication(roomTitle);
      setConfirm('사용 가능한 방 제목입니다.');
      setRoomTitleDuplication(true);
    } catch (err: any) {
      setError('중복된 방 제목입니다.');
    }
  };

  const handleConfirm = async () => {
    if (roomTitle === '' || mainPassword === '' || subPassword === '') {
      setError(blankMsg);
      return;
    }

    if (!roomTitleDuplication) {
      setError('방 제목 중복 확인을 해주세요.');
      return;
    }

    if (mainPassword === subPassword) {
      setError('고정ㆍ용차 비밀번호는 같지 않아야 합니다.');
      return;
    }

    const formData: RoomMakeDto = {
      title: roomTitle,
      belongedPassword: mainPassword,
      borrowedPassword: subPassword,
    };

    try {
      await roomAPI.roomMake(formData);
      setModalState(false);
      navigate('/myroomlist');
      setConfirm('방 생성이 완료되었습니다.');
    } catch {
      setError('방 생성에 실패했습니다.');
    }
  };

  return (
    <>
      <InputModal
        title="방 만들기"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>
              방 제목
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <InputBox>
              <CS.TextInputType1
                type="text"
                placeholder="방 제목 입력 (18자 이하)"
                aria-label="방 제목 입력 필드"
                value={roomTitle}
                onChange={(e) => {
                  setRoomTitle(e.target.value);
                  setRoomTitleDuplication(false);
                }}
              />
              <CS.Btn6Type1
                onClick={handleRoomTitleDuplication}
                disabled={roomTitleDuplication}
              >
                {roomTitleDuplication ? '완료' : '중복 확인'}
              </CS.Btn6Type1>
            </InputBox>
          </li>
          <li>
            <h2>
              고정 비밀번호
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1
              type="password"
              placeholder="고정 비밀번호 입력"
              value={mainPassword}
              onChange={(e) => setMainPassword(e.target.value)}
              aria-label="고정 비밀번호 입력 필드"
            />
          </li>
          <li>
            <h2>
              용차 비밀번호
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1
              type="password"
              placeholder="용차 비밀번호 입력"
              value={subPassword}
              onChange={(e) => setSubPassword(e.target.value)}
              aria-label="용차 비밀번호 입력 필드"
            />
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default RoomMake;

const InputBox = styled.div`
  display: flex;
  gap: 8px;

  > input {
    width: calc(100% - 76px);
  }
`;
